module.exports = __webpack_public_path__ + "media/gem-found-yellow.2a50eb4d.mp4";